import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { IconeDownload } from "../../IconeDownload";
import { IrmaoTable } from "../../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";

export const Restricoes = ({ data }) => {
  const columnsRestricoes = [
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Nome",
      accessor: "pessoaRestricao.nome",
      Cell: (props) => {
        return <Text whiteSpace={"normal"}>{props.value}</Text>;
      },
    },
    {
      Header: "Vínculo",
      accessor: "vinculo",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value}</Text>;
      },
    },
    {
      Header: "Proibição",
      accessor: "possuiAnexoRestricao",
      Cell: (props) => {
        return (
          <span>
            {props.value ? (
              <Flex justifyContent={"center"}>
                <button>
                  <IconeDownload />
                </button>
              </Flex>
            ) : (
              ""
            )}
          </span>
        );
      },
      disableSortBy: true,
    },
    {
      Header: "Data de proibição",
      accessor: "dataProibicao",
      Cell: (props) => {
        const custom_date = new Date(props?.value).toLocaleDateString("pt-BR");
        return <span>{props.value ? custom_date : ""}</span>;
      },
      disableSortBy: true,
    },
    {
      Header: "Liberação",
      accessor: "possuiAnexoLiberacao",
      Cell: (props) => {
        return (
          <span>
            {props.value ? (
              <Flex justifyContent={"center"}>
                <button>
                  <IconeDownload />
                </button>
              </Flex>
            ) : (
              ""
            )}
          </span>
        );
      },
      disableSortBy: true,
    },
    {
      Header: "Data de liberação",
      accessor: "dataLiberacao",
      Cell: (props) => {
        const custom_date = new Date(props?.value).toLocaleDateString("pt-BR");
        return <span>{props.value ? custom_date : ""}</span>;
      },
      disableSortBy: true,
    },
  ];

  return data && data.length > 0 ? (
    <Box className="break-page">
      <Flex>
        <Group bgColor="#fff" title="Restrições" py="12px" mtDivider="5px">
          <IrmaoTable
            disableHeaderOptions={true}
            columns={columnsRestricoes}
            data={data}
            entidade={"restricoes"}
            restricoes={true}
            filiacoes={data}
            isPrint={true}
          />
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="restricoes"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
